import request from './.request-cloud.js'

export function equipList() {
  return request({
    url: '/device/config',
    method: 'get'
  })
}

export function monitorData(e) {
  return request({
    url: `/realtime/${e}`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/demo.js